import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import {Header2} from 'ui-library/Headers';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {Optional} from 'util/Types';

interface SectionProps {
  title: string;
  icon?: Optional<string>;
  children: ReactNode;
}

export default function Section({title, icon, children}: SectionProps): JSX.Element {
  return (
    <div>
      <div className={css(styles.sectionHeaderContainer)}>
        <Header2 className={css(styles.sectionHeader)}>
          {icon && <BenchlingIcon icon="lock" className={css(styles.sectionIcon)} />}
          {title}
        </Header2>
        <hr className={css(styles.sectionHeaderRule)} />
      </div>
      {children}
    </div>
  );
}

const styles = StyleSheet.create({
  sectionHeaderContainer: {
    display: 'flex',
    alignItems: 'flex-end', // Effect: <hr> is aligned with the center of the <h2> text.
    gap: 5,
    marginTop: 15,
    marginBottom: 15,
  },
  sectionHeader: {
    flex: 'none',
  },
  sectionHeaderRule: {
    flex: '1',
    borderTopWidth: 2,
  },
  sectionIcon: {
    marginRight: 8,
  },
});
